(function (app, ng) {

    app.config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state("Transaction.Determine.ProductShelf",
            {
                url: "/ProductShelf",
                component: "productShelf",
                resolve: {
                    products: ["transactionProductApi", "$transition$", function (transactionProductApi, $transition$) {
                        return transactionProductApi.getTransactionProducts($transition$.params().transactionId);
                    }]
                },
                onEnter: ["transaction", "transactionApi", function (transaction, transactionApi) {
                    transaction.LastTransactionStage = "ProductShelf";
                    transactionApi.updateLastTransactionStage(transaction.Id, transaction);
                }]
            });
    }]);

    app.component("productShelf",
        {
            templateUrl: "/App/Transaction/Determine/ProductShelf/template.html",
            controller: productShelfController,
            bindings: {
                products: "<",
                transaction: "<",
            }
        });

    productShelfController.$inject = ["$state", "$scope", "_", "transactionApi", "productApi", "transactionPrefillApi", "$location", "$mdDialog", "rightBridgeApi", "retireUpApi", "arcEnrollments", "arcEnrollmentsApi"];
    function productShelfController($state, $scope, _, transactionApi, productApi, transactionPrefillApi, $location, $mdDialog, rightBridgeApi, retireUpApi, arcEnrollments, arcEnrollmentsApi) {
        this.$state = $state;
        this.$scope = $scope;
        var $ctrl = this;

        $ctrl.transactionPrefillApi = transactionPrefillApi;
        $scope.$parent.$ctrl.getCurrentStage($state);

        arcEnrollments.then(function (e) {
            arcEnrollmentsApi.isEnrolled(e.retireUpId).then(function (response) {
                $ctrl.RetireUpIsEnrolled = response;
            });
        });

        ng.extend($ctrl,
            {
                UI: {},
                save: save,
                filterRightBridgeCusips: filterRightBridgeCusips,
                filterRetireUpCusips: filterRetireUpCusips,
                filterWithOutRightBridgeCusips: filterWithOutRightBridgeCusips,
                filterWithOutRetireUpCusips: filterWithOutRetireUpCusips,
                goNext: goNext,
                submitApp: submitApp,
                activateRightBridgeSso: activateRightBridgeSso,
                activateRetireUpSso: activateRetireUpSso,
                filterVendorCusips: filterVendorCusips
            });

        function save(transactionProductId, productId) {
            $ctrl.UI.Saving = true;
            return transactionApi.updateTransactionProduct($ctrl.transaction.Id, { Id: $ctrl.transaction.Id, TransactionProductId: transactionProductId }).then(function () {
                if (transactionProductId === null) {
                    $ctrl.transaction.Product = null;
                    getNextStage(false);
                    $ctrl.UI.Saving = false;

                } else
                    return productApi.getProduct(productId)
                        .then(function (product) {
                            $ctrl.transaction.Product = product;
                            getNextStage(true);
                            $ctrl.UI.Saving = false;
                        });

            });
        }

        function getNextStage(productSelected) {
            if ($ctrl.transaction.DeterminePoints.includes("DetermineDocuments")) {
                $ctrl.nextStage = "Documents";
            }
            else {
                if ($ctrl.transaction.Product) {
                    productApi.getProduct($ctrl.transaction.Product.Id).then(function (prod) {
                        $ctrl.nextStage = prod.Plugins.includes("FireLight")
                            ? "FireLight"
                            : "FormsPipeLine";

                    });
                } else {
                    if (!productSelected)
                        $ctrl.nextStage = "NoSuitableProduct";
                }
            }
        }

        function filterVendorCusips(obj) {
            var arr = [];
            var allow = false;
            if ($ctrl.rightBridgeResponseCusips) {
                var indexRb = _.findIndex($ctrl.rightBridgeResponseCusips, function (cus) {
                    return cus === obj.RightBridgeProductCode;
                });

                if (indexRb !== -1) {
                    arr.push("RightBRIDGE");
                    allow = true;
                }

            }

            if ($ctrl.retireUpResponseCusips) {
                var indexRu = _.findIndex($ctrl.retireUpResponseCusips, function (cus) {
                    return cus === obj.RetireUpProductCode;
                });

                if (indexRu !== -1) {
                    arr.push("RetireUp Pro");
                    allow = true;
                }
            }

            obj.Vendors = arr.join(", ");
            return allow;
        }

        function filterRightBridgeCusips(obj) {
            if ($ctrl.rightBridgeResponseCusips) {
                var index = _.findIndex($ctrl.rightBridgeResponseCusips, function (cus) {
                    return cus === obj.RightBridgeProductCode;
                });

                if (index !== -1)
                    return true;

                return false;
            }
            return false;
        }

        function filterRetireUpCusips(obj) {
            if ($ctrl.retireUpResponseCusips) {
                var index = _.findIndex($ctrl.retireUpResponseCusips, function (cus) {
                    return cus === obj.RetireUpProductCode;
                });

                if (index !== -1)
                    return true;

                return false;
            }
            return false;
        }

        function filterWithOutRightBridgeCusips(obj) {
            if ($ctrl.rightBridgeResponseCusips) {
                var index = _.findIndex($ctrl.rightBridgeResponseCusips, function (cus) {
                    return cus === obj.RightBridgeProductCode;
                });

                if (index === -1)
                    return true;

                return false;
            }
            return true;
        }

        function filterWithOutRetireUpCusips(obj) {
            if ($ctrl.retireUpResponseCusips) {
                var index = _.findIndex($ctrl.retireUpResponseCusips, function (cus) {
                    return cus === obj.RetireUpProductCode;
                });

                if (index === -1)
                    return true;

                return false;
            }
            return true;
        }

        function goNext($event) {
            if ($ctrl.nextStage === "NoSuitableProduct") {
                $state.go("Transaction.Determine.Documents", { transactionid: $ctrl.transaction.Id });
                //submitApp($event);            
            }

            else if ($ctrl.nextStage === "FireLight")
                $state.go("Transaction.Application.Prefill", { transactionId: $ctrl.transaction.Id });
            else if ($ctrl.nextStage === "FormsPipeline")
                $state.go("Transaction.Application.FormsPipeline", { transactionId: $ctrl.transaction.Id });
            else
                $state.go("Transaction.Determine.Documents", { transactionid: $ctrl.transaction.Id });
        }
        function submitApp($event) {
            var leave = $mdDialog.confirm({
                title: "Are you sure you would like to end this transaction?",
                htmlContent: "<h4>You selected No Suitable Product.</h4><p>If you choose to continue, your transaction will be compiled and submitted for review.</p> <p> Any edits to this transaction in the future will be unavailable.</p>",
                targetEvent: $event,
                ariaLabel: "Confirm submitting transaction",
                ok: "Submit",
                cancel: "Cancel",
                skipHide: true,
                clickOutsideToClose: false
            });
            $mdDialog.show(leave)
                .then(function () {
                    $ctrl.ui.generating = true;
                    updateStatus("NoSuitableProduct");
                });
        }

        function updateStatus(status) {
            $ctrl.transaction.TransactionStatus = status;
            return transactionApi.updateTransactionStatus($ctrl.transaction.Id, $ctrl.transaction).then(function () {
                $ctrl.ui.generating = false;
                $state.go("Home.ViewTransactions");
            });
        }

        function getRightBridgeResponse() {
            return transactionApi.getTransactionRightBridgeResponse($ctrl.transaction.Id);
        }

        function getRetireUpResponse() {
            return transactionApi.getTransactionRetireUpResponse($ctrl.transaction.Id);
        }

        this.$onInit = function () {

            $ctrl.rightBridgeResponseCusips = [];
            $ctrl.retireUpResponseCusips = [];
            $ctrl.UI.HasRightBridge = $ctrl.transaction.DeterminePoints.includes("Rightbridge");
            $ctrl.UI.HasRetireUp = $ctrl.transaction.DeterminePoints.includes("RetireUp");


            if ($ctrl.UI.HasRightBridge) {
                getRightBridgeResponse().then(function (data) {
                    try {
                        var rbJsonData = JSON.parse(data.JsonData);
                        var vars = _.map(rbJsonData, "vars")[0];
                        var varSets = _.map(vars, "varSet");
                        _.find(varSets, function (vSetRow) {
                            if (vSetRow.name === "AWSelectedProductIncome" || vSetRow.name === "AWSelectedProductAccumulation") {
                                _.find(vSetRow.vars, function (v) {
                                    if (v.var.name === "Cusip") {
                                        var cusips = v.var.value.split("|");
                                        ng.forEach(cusips, function (c) {
                                            if (c.length)
                                                $ctrl.rightBridgeResponseCusips.push(c);
                                        });
                                    }
                                });
                            }
                        });
                        console.log(data.JsonData);
                        console.log(rbJsonData);
                        console.log($ctrl.rightBridgeResponseCusips);

                    }
                    catch (e) {
                        console.log(e)
                        console.log("Error parsing RightBridge Json data");
                    }
                });
            }

            if ($ctrl.UI.HasRetireUp) {
                getRetireUpResponse().then(function (data) {
                    try {
                        var ruJsonData = JSON.parse(data.JsonData);
                        _.find(ruJsonData,
                            function (vSetRow) {
                                if (vSetRow.accounts.annuity.length) {
                                    if (vSetRow.accounts.annuity[0].product.cusip !== null) {
                                        var cusip = vSetRow.accounts.annuity[0].product.cusip.toUpperCase();
                                        $ctrl.retireUpResponseCusips.push(cusip);
                                    }
                                }
                            });

                        console.log(data.JsonData);
                        console.log(ruJsonData);
                        console.log($ctrl.retireUpResponseCusips);

                    } catch (e) {
                        console.log("Error parsing RetireUp Json data");
                    }
                });
            }

            $ctrl.carrierList = [];
            $ctrl.lobcList = [];
            ng.forEach($ctrl.products, function (p) {
                var carrierIndex = _.findIndex($ctrl.carrierList, function (row) { return row.Id === p.CarrierId });
                if (carrierIndex === -1)
                    $ctrl.carrierList.push({ Id: p.CarrierId, Name: p.CarrierName });

                var lobcIndex = _.findIndex($ctrl.lobcList, function (row) { return row.Id === p.LineOfBusinessCategoryId });
                if (lobcIndex === -1)
                    $ctrl.lobcList.push({ Id: p.LineOfBusinessCategoryId, Name: p.LineOfBusinessCategoryName });

            });
            getNextStage(true);
        };

        function activateRightBridgeSso() {
            var w = window;
            w.document.write("Loading...");
            rightBridgeApi.initiateRightBridgeSso($ctrl.transaction.Id).then(function (data) {
                w.document.write(data);
                w.document.forms.samlform.submit();
            }, function (error) {
                w.document.write(" Failed.  There was an error accessing this resource.");
            });
        }

        function activateRetireUpSso() {
            if ($ctrl.RetireUpIsEnrolled) {

                var w = window;
                w.document.write("Loading...");
                retireUpApi.initiateRetireUpSso($ctrl.transaction.Id).then(function (data) {
                    console.log(data)
                    w.document.write(data);
                    w.document.forms.samlform.submit();
                }, function (error) {
                    w.document.write(" Failed.  There was an error accessing this resource.");
                });
            }
        }
    }
})(window.app, window.angular);